import { ChatWithFeedbackInput } from '@modules/chatWithFeedback/components/ChatWithFeedbackInput';
import { AutocompleteProps, Stack } from '@mui/material';

interface FeedbackListSummaryEmptyStateProps {
  isLoading: boolean;
  isSummaryGenerationInProgress: boolean;
  onStopSummaryGeneration: () => void;
  onSubmit: () => void;
  shouldShowLoader: boolean;
  value?: string;
  onChange: (value?: string) => void;
  isFeedbackSidebarView?: boolean;
  submittedPrompt: string;
  autoCompleteProps?: Partial<AutocompleteProps<string, false, true, true>>;
}

export const FeedbackListSummaryEmptyState = ({
  isLoading,
  onSubmit,
  onStopSummaryGeneration,
  isSummaryGenerationInProgress,
  shouldShowLoader,
  value,
  onChange,
  isFeedbackSidebarView,
  submittedPrompt,
  autoCompleteProps,
}: FeedbackListSummaryEmptyStateProps) => {
  return (
    <Stack width="90%" alignItems="center" justifyContent="center">
      <ChatWithFeedbackInput
        showHelperTextOnActive
        onSubmit={onSubmit}
        value={value}
        onChange={onChange}
        shouldShowLoader={shouldShowLoader}
        isSummaryGenerationInProgress={
          isSummaryGenerationInProgress || isLoading
        }
        onStopSummaryGeneration={onStopSummaryGeneration}
        isFeedbackSidebarView={isFeedbackSidebarView}
        submittedPrompt={submittedPrompt}
        isCompleted={false}
        autoCompleteProps={autoCompleteProps}
      />
    </Stack>
  );
};
